import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import InteractionsCorrectResponsesObjectInterface
  from "@/lib/ScormApi/Scorm2004/interfaces/InteractionsCorrectResponsesObjectInterface"

export default function InteractionsCorrectResponsesObject (api: ScormAPI2004): InteractionsCorrectResponsesObjectInterface {
  let _pattern = "" // Data type changes based on interaction's type

  return {
    get pattern () {
      return _pattern
    },
    set pattern (pattern) {
      _pattern = pattern
    },
    toJSON: new JsonFormatter().apply
  }
}
